import React from "react";
import ExcalidrawViewer from "../../components/ExcalidrawViewer";

const SeamlessChatModule: React.FC = () => (
  <ExcalidrawViewer
    filePath="/excalidraw/seamless-chat-module.excalidraw"
    title="Seamless Chat Module — Architecture & Flow"
    subtitle="Zero-friction chat: SMS link → anonymous identity → instant messaging → progressive auth to phone login. Built on GraphQL Subscriptions + WebSocket."
  />
);

export default SeamlessChatModule;
